var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFollow = function SvgFollow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M33.874 20.048L32.729 8.982h3.95a2.246 2.246 0 0 0 2.245-2.245V2.246A2.246 2.246 0 0 0 36.678 0h-25.45a2.246 2.246 0 0 0-2.246 2.246v4.49a2.246 2.246 0 0 0 2.246 2.246h3.95l-1.146 11.066c-4.538 2.11-8.044 5.895-8.044 10.642a2.246 2.246 0 0 0 2.246 2.246h12.725v9.731c0 .117.027.231.08.335l2.245 4.491a.75.75 0 0 0 1.339 0l2.245-4.49a.75.75 0 0 0 .08-.336v-9.731h12.725a2.246 2.246 0 0 0 2.245-2.246c0-4.789-3.554-8.554-8.044-10.642z"
  })));
};
export default SvgFollow;